import script from "./BannerLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerLanding.vue?vue&type=script&setup=true&lang=js"

import "./BannerLanding.vue?vue&type=style&index=0&id=1823d2b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1823d2b2"]])

export default __exports__